import { Loader2 } from "lucide-react";
import Typography from "../components/Typography";

export function AuthLoaderPage() {
  return (
    <div className="flex flex-col items-center justify-center h-screen gap-4">
      <Loader2 className="h-8 w-8 animate-spin" />
      <Typography variant="h5" className="text-xl text-gray-500">
        Loading User Information...
      </Typography>
    </div>
  );
}
